export default __webpack_public_path__ + "static/media/share-red.d2bc775c.svg";